/*  MUI  */
import { Drawer, List, ListItem, ListItemIcon } from '@mui/material';

/*  React  */
import React, { Component } from 'react';

class StepsDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    renderStep = (step) => {
        const { iconSx } = this.props;
        const { num, icons, active, text } = step;
        const icon = active ? icons.active : icons.inactive;

        return (
            <div key={num}>
                <ListItem
                    disablePadding
                    disableGutters
                    style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginLeft: 0
                    }}
                >
                    <ListItemIcon sx={iconSx}>{icon}</ListItemIcon>
                </ListItem>
                <ListItem
                    disablePadding
                    disableGutters
                    sx={{
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                >
                    <small>{text}</small>
                </ListItem>
            </div>
        );
    };

    render() {
        const { open, steps } = this.props;

        return (
            <Drawer
                variant="permanent"
                open={open}
                sx={{
                    '& .MuiDrawer-root': { position: 'absolute' },
                    '& .MuiPaper-root': {
                        display: 'block',
                        flex: 'none',
                        position: 'absolute'
                    }
                }}
                PaperProps={{
                    sx: {
                        position: 'absolute'
                    }
                }}
            >
                <List>{steps.map((step) => this.renderStep(step))}</List>
            </Drawer>
        );
    }
}

export default StepsDrawer;
